module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQBAMAAAD+CqKmAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTP6dLP+fL/+XMP+fIP6cK/2cLf+eLf+eLv6cLP6cLDzYddkAAAAKdFJOUwDfICAQz6A/X7/i5+T1AAAATElEQVQI12NgwA8UhRFsJqmFBgiJVauEERJLZ8GlFFeFsMGkgBIODFlQKaAEAwNUCizBAJUCS8CkIBIgKRAnBGIOG4ij4QC1oQSPewFh+xLvJR3f2QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa/years/收起@2x.png
// module id = EHxS
// module chunks = 1